/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon20Light = forwardRef('ArrowUiAuthLogoutIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 5a3 3 0 0 1 3-3h5.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h5.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3V5Z" }),
        React.createElement("path", { d: "M16.784 9H7.5a.5.5 0 0 0 0 1h9.284l-3.248 3.247a.5.5 0 0 0 .707.707l3.273-3.272a1.672 1.672 0 0 0 0-2.365l-3.273-3.273a.5.5 0 1 0-.707.707L16.784 9Z" })));
});
